import styled from 'styled-components';

const StyledButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin: 10px 0;
  padding: 10px 16px;
  font-size: 1em;
  font-weight: bold;
  border: none;
  border-radius: 4px;
  background-color: var(--primary-color, #007bff);
  color: var(--text-color, #ffffff);
  cursor: pointer;
  transition: background-color 0.3s, transform 0.2s;

  &:hover {
    background-color: var(--primary-color-hover, #0056b3);
    transform: scale(1.02);
  }

  &:active {
    background-color: var(--primary-color-active, #004085);
    transform: scale(0.98);
  }

  &:focus {
    background-color: var(--primary-focus-color, #0062cc); /* Slightly lighter shade for focus */
    outline: none; /* Remove default outline */
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.5); /* Add a focus ring */
  }

`;

export default StyledButton;
